import React, { useContext, useEffect, useRef, useState } from 'react'

import { WappContext, withWapp } from 'wapplr-react/dist/common/Wapp'
import getUtils from 'wapplr-react/dist/common/Wapp/getUtils'

import Button from 'karrierhub-ui/dist/common/src/components/Button'
import Container from 'karrierhub-ui/dist/common/src/components/Container'
import Color from 'karrierhub-ui/dist/common/src/components/Color'
import { Divider } from 'karrierhub-ui/dist/common/src/components/MenuItem'
import Typography from 'karrierhub-ui/dist/common/src/components/Typography'

import capitalize from '../../../utils/capitalize'
import { runPostTypesConfigSync } from '../../../postTypes'

import AppContext from '../../App/context'
import Form from '../../Form'
import Dialog from '../../Dialog'

import AccountContext from '../context'

import Social from './social'

import style from './style.css'


function Signup(props) {

    const accountContext = useContext(AccountContext)

    const {
        name,
        documentName = 'page',
        termsSlug = 'terms',
        privacySlug = 'privacy',
        acceptTermsPropertyName = 'acceptTerms',
        acceptPrivacyPropertyName = 'acceptPrivacy',
        parentRoute
    } = accountContext

    const N = capitalize(name)

    const context = useContext(WappContext)
    const appContext = useContext(AppContext)
    const utils = getUtils(context)

    const { wapp, req } = context

    wapp.styles.use(style)

    const form = useRef()
    const dialog = useRef()
    const _formData = useRef()

    const dialogEffect = ({ actions }) => {
        dialog.actions = actions
    }

    const query = req.wappRequest.query

    let approvedSlugs = {
        [acceptTermsPropertyName]: new Set(),
        [acceptPrivacyPropertyName]: new Set()
    }

    function openTermsAndPrivacy(e, slug, propertyName) {

        e.preventDefault()
        e.stopPropagation()

        if (dialog.actions) {

            function DialogContent({ slug }) {

                const context = useContext(WappContext)
                const { wapp, req, res } = context

                const requestName = documentName + 'FindBySlug'
                const posts = [utils.getGlobalState('res.responses.' + documentName + 'FindById'), utils.getGlobalState('res.responses.' + requestName)]
                const initialPost = posts.find((p) => p?.slug === slug)

                const [response, setResponse] = useState(initialPost ? { [requestName]: initialPost } : null)

                const post = response && response[requestName]?._id ? response[requestName] : null

                const path = (appContext.routes[documentName + 'Route'] && slug) ? appContext.routes[documentName + 'Route'] + '/' + slug : null

                const newContext = (path && slug) ?
                    {
                        wapp,
                        req: {
                            user: req.user,
                            wappRequest: {
                                user: req.wappRequest.user
                            }
                        },
                        res: {
                            wappResponse: {
                                route: {
                                    requestPath: path,
                                    params: { _id: slug }
                                },
                                store: res.wappResponse.store,
                                status: res.wappResponse.status
                            }
                        }
                    } : context

                const PostTypesComponent = (path) ? runPostTypesConfigSync({
                    action: 'getComponent',
                    p: { context: newContext, appContext }
                }).filter((C) => !!(C))[0] : null

                const content = wapp.contents.get(documentName)

                async function request({ wapp, req, res }) {
                    if (content && content.request) {
                        const response = await content.request({ wapp, req, res })
                        await setResponse(response)
                    }
                }

                useEffect(() => {
                    if (path && !post?._id) {
                        // noinspection JSIgnoredPromiseFromCall
                        request(newContext)
                    }
                }, [])

                return (
                    <WappContext.Provider value={newContext}>
                        <div>
                            {(post && PostTypesComponent) ? <PostTypesComponent post={post} /> : null}
                        </div>
                    </WappContext.Provider>
                )
            }

            dialog.actions.open({
                dialogTitle: appContext.titles[propertyName + 'TitleFor' + capitalize(slug)],
                dialogContent: <>
                    <DialogContent slug={slug} />
                </>,
                cancelText: appContext.labels['cancel' + N + 'Text'],
                submitText: appContext.labels[propertyName + 'LabelFor' + capitalize(slug)],
                onCancel: async (e) => {
                    if (e) {
                        e.preventDefault()
                    }
                    await dialog.actions.close()
                },
                onSubmit: async (e) => {
                    if (e) {
                        e.preventDefault()
                    }
                    approvedSlugs[propertyName].add(slug)

                    if (form.current) {
                        const requiredSlugs = getRequiredSlugs(propertyName)
                        const allApproved = requiredSlugs.every(slug => approvedSlugs[propertyName].has(slug))

                        if (allApproved) {
                            form.current.items[propertyName].actions.setValue([true])
                        }
                    }
                    await dialog.actions.close()
                },
                dialogContentClassName: style.dialogContent
            })

        }
    }

    function getRequiredSlugs(propertyName) {
        if (propertyName === acceptTermsPropertyName) {
            return [termsSlug, privacySlug]
        } else if (propertyName === acceptPrivacyPropertyName) {
            return [privacySlug]
        }
        return []
    }


    async function onSubmit(e, formData) {

        let response = await utils.signup({
            requestName: name + 'Signup',
            args: formData,
            ...typeof props.redirect !== 'undefined' && props.redirect !== parentRoute + '/logout' ?
                {
                    redirect: props.redirect
                } : {
                    redirect: {
                        pathname: query.redirect && query.redirect !== parentRoute + '/logout' ? query.redirect : appContext.routes.userRoute + '/:_id',
                        search: '',
                        hash: ''
                    }
                }
        })

        if (props.onSubmit) {
            const newResponse = await props.onSubmit(e, response)
            if (newResponse) {
                return newResponse
            }
        }

        return response

    }

    function replace(props) {
        const { text, words, propertyName, slugs } = props

        const regex = new RegExp(`(${words.join('|')})`, 'gi')

        const textA = (typeof text === 'string') ? [text] : text

        return textA.map((text) => {
            if (typeof text === 'string' && text.match(regex)) {
                let slugMapping = words.reduce((acc, word, index) => {
                    acc[word.toLowerCase()] = slugs[index] || ''
                    return acc
                }, {})

                return text.split(regex).map((part, index) => {
                    const matchedWord = words.find(word => word.toLowerCase() === part.toLowerCase())
                    if (matchedWord) {
                        const slug = slugMapping[matchedWord.toLowerCase()] || ''
                        const href = (documentName && appContext.routes[documentName + 'Route'] && slug)
                            ? appContext.routes[documentName + 'Route'] + '/' + slug
                            : ''

                        return (
                            <Color color={'ttm'} Component={'span'} key={index}>
                                <Button
                                    stopPropagation={true}
                                    variant={'inline'}
                                    href={href}
                                    onClick={href ? (e) => openTermsAndPrivacy(e, slug, propertyName) : null}
                                    tabIndex={-1}
                                    style={{ textDecoration: 'underline' }}
                                >
                                    {part}
                                </Button>
                            </Color>
                        )
                    }
                    return part
                })
            }
            return [text]
        }).reduce((a, value) => {
            a.push(...value)
            return a
        }, [])
    }

    function getFormData(acceptProperties) {

        let formDataFromResolvers = {}
        try {
            formDataFromResolvers = utils.getGlobalState('res.graphql.mutation.' + name + 'Signup.formData')
        } catch (e) {
        }

        const formData = {
            ...formDataFromResolvers,
            submit: {
                label: appContext.labels.signupSubmitLabel,
                fullWidth: true,
                size: 'input-' + props.size,
                TypographyProps: {
                    variant: 'button-' + props.size
                }
            }
        }

        acceptProperties.forEach(({ propertyName, slugs, words }) => {
            if (formData[propertyName] && typeof formData[propertyName].label === 'string') {
                const data = { ...formData[propertyName] }

                if (data.required && !data.label.endsWith(' *')) {
                    data.label += ' *'
                }

                const newLabelParts = replace({
                    propertyName,
                    slugs,
                    text: data.label,
                    words,
                    style: { textDecoration: 'underline' }
                })

                if (newLabelParts.length > 1) {
                    data.label = (
                        <>
                            {newLabelParts.map((value, i) => <React.Fragment key={i}>{value}</React.Fragment>)}
                        </>
                    )
                } else {
                    data.label = (
                        <Color color={'ttm'} Component={'span'}>
                            <Button
                                stopPropagation={true}
                                variant={'inline'}
                                href={newLabelParts.length > 0 ? newLabelParts[0].props.href : ''}
                                onClick={newLabelParts.length > 0 ? newLabelParts[0].props.onClick : null}
                                tabIndex={-1}
                            >
                                {data.label}
                            </Button>
                        </Color>
                    )
                }

                formData[propertyName] = data
            }
        })

        return formData
    }

    const formData = getFormData([
        ...termsSlug && acceptTermsPropertyName ? [{
            propertyName: acceptTermsPropertyName,
            slugs: [termsSlug, privacySlug],
            words: [appContext.labels.termsWord || 'terms', appContext.labels.privacyWord || 'privacy']
        }] : [],
        ...privacySlug && acceptPrivacyPropertyName ? [{
            propertyName: acceptPrivacyPropertyName,
            slugs: [privacySlug],
            words: [appContext.labels.privacyWord || 'privacy']
        }] : []
    ])

    formData['record.col1'] = {
        isContainer: true,
        hiddenContainer: true
    }

    formData['email'].transformValue = (value) => {
        if (value) {
            value = value.trim()
        }
        return value
    }
    formData['email'].enableUpdateValueAfterTransform = true

    formData['record.businessName'].hidden = true

    formData['password'].containerKey = 'record.col1.passwords.password'
    formData['passwordAgain'].containerKey = 'record.col1.passwords.passwordAgain'

    formData['record.col1.passwords'] = {
        isContainer: true,
        hiddenContainer: true
    }

    _formData.current = formData

    return (
        <Container containerVariant={'parent'}>
            <Container className={style.signup} container-type={'parent-side'}>
                <Form
                    className={style.form}
                    ref={form}
                    formData={formData}
                    onSubmit={onSubmit}
                    onChange={async (e, key, fD) => {

                        _formData.current = fD

                        if (key === 'acceptTerms') {
                            if (!fD[key].value) {
                                approvedSlugs[key].clear()
                            } else {
                                approvedSlugs[key].add(termsSlug)
                                approvedSlugs[key].add(privacySlug)
                            }
                        }

                        if (key === 'record.userType') {
                            const value = fD[key].value
                            if (value === 'employer') {
                                _formData.current['record.businessName'].hidden = false
                                _formData.current['record.businessName'].required = true
                                if (typeof _formData.current['record.businessName']._tempValue !== 'undefined') {
                                    _formData.current['record.businessName'].value = _formData.current['record.businessName']._tempValue
                                    delete _formData.current['record.businessName']._tempValue
                                }
                            } else {
                                _formData.current['record.businessName'].hidden = true
                                _formData.current['record.businessName'].required = false
                                _formData.current['record.businessName']._tempValue = _formData.current['record.businessName'].value
                                _formData.current['record.businessName'].value = ''
                            }
                            await form.current.setNewFormData(_formData.current)
                        }

                    }}
                />
                <Divider />
                <Social {...props} />
                <Button
                    color={'tertiary'}
                    href={parentRoute + '/login' + (query.redirect ? '?redirect=' + encodeURIComponent(query.redirect) : '')}
                    size={props.size}
                    fullWidth={true}
                >
                    <div className={style.loginButtonLabel}>
                        <Typography Component={'div'}
                                    variant={'subtitle2'}>{appContext.labels.loginQuestion}</Typography>
                        <div>{appContext.labels.nextToLogin}</div>
                    </div>
                </Button>
                <Dialog
                    effect={dialogEffect}
                    className={style.dialog}
                    paperClassName={style.dialogPaper}
                    ContentComponentProps={{
                        Component: 'div'
                    }}
                />
            </Container>
        </Container>
    )
}

export default withWapp(Signup)
